module.exports = __webpack_public_path__ + "d48d65c2a8ea8fe0e4d0b4f53df10c32.png";